/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import { SignatureType, SignatureTypeFromJSON, SignatureTypeFromJSONTyped, SignatureTypeToJSON } from './SignatureType'

/**
 *
 * @export
 * @interface SignedSignInToNominexDomain
 */
export interface SignedSignInToNominexDomain {
  /**
   *
   * @type {string}
   * @memberof SignedSignInToNominexDomain
   */
  action?: string
  /**
   *
   * @type {string}
   * @memberof SignedSignInToNominexDomain
   */
  address?: string
  /**
   *
   * @type {number}
   * @memberof SignedSignInToNominexDomain
   */
  referrerId?: number
  /**
   *
   * @type {number}
   * @memberof SignedSignInToNominexDomain
   */
  timestamp?: number
  /**
   *
   * @type {string}
   * @memberof SignedSignInToNominexDomain
   */
  signature?: string
  /**
   *
   * @type {SignatureType}
   * @memberof SignedSignInToNominexDomain
   */
  signatureVersion?: SignatureType
}

export function SignedSignInToNominexDomainFromJSON(json: any): SignedSignInToNominexDomain {
  return SignedSignInToNominexDomainFromJSONTyped(json, false)
}

export function SignedSignInToNominexDomainFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SignedSignInToNominexDomain {
  if (json === undefined || json === null) {
    return json
  }
  return {
    action: !exists(json, 'action') ? undefined : json['action'],
    address: !exists(json, 'address') ? undefined : json['address'],
    referrerId: !exists(json, 'referrerId') ? undefined : json['referrerId'],
    timestamp: !exists(json, 'timestamp') ? undefined : json['timestamp'],
    signature: !exists(json, 'signature') ? undefined : json['signature'],
    signatureVersion: !exists(json, 'signatureVersion') ? undefined : SignatureTypeFromJSON(json['signatureVersion']),
  }
}

export function SignedSignInToNominexDomainToJSON(value?: SignedSignInToNominexDomain | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    action: value.action,
    address: value.address,
    referrerId: value.referrerId,
    timestamp: value.timestamp,
    signature: value.signature,
    signatureVersion: SignatureTypeToJSON(value.signatureVersion),
  }
}
